import { TestRow } from "../../api/test.type";
import Card from "../shared/card";
import Typography from "../shared/typography";
import { formatTimeStampToHumanReadableDate } from "../utls/time";
import RecordMetaGrid, {
  RecordMetaItem,
} from "../medical-records/record-meta-grid";

interface TestSummaryItemProps {
  test: TestRow;
  onClick?: () => void;
}

export default function TestSummaryItem({
  test,
  onClick,
}: TestSummaryItemProps) {
  const { test_type, test_id, test_category, test_date } = test;
  const meta: RecordMetaItem[] = [];

  if (test_category) {
    meta.push({ label: "Category", value: test_category });
  }

  if (test_date) {
    meta.push({
      label: "Date",
      value: formatTimeStampToHumanReadableDate(test_date),
    });
  }

  return (
    <Card
      variant="cream"
      elevation={1}
      className="w-full"
      onClick={onClick}
      hoverEffect={!!onClick}
    >
      <Card.Body className="space-y-1">
        {(test_type || test_id) && (
          <Typography variant="subtitle1" className="text-brown-800">
            {test_type || test_id}
          </Typography>
        )}
        <RecordMetaGrid
          items={meta}
          columnsClassName="sm:grid-cols-2 lg:grid-cols-4"
        />
      </Card.Body>
    </Card>
  );
}
